import { useMutation } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { IStandardsSetContentRelationResponse } from "../../types/IStandardsSetContentRelationResponse";

interface UpdateDraftStandardsSetProps {
  title: string;
  standardsSetId: string;
}

export const useUpdateStandardsSetDraft = () => {
  return useMutation<
    IStandardsSetContentRelationResponse | void,
    Error,
    UpdateDraftStandardsSetProps
  >({
    mutationFn: async ({
      title,
      standardsSetId,
    }: UpdateDraftStandardsSetProps): Promise<IStandardsSetContentRelationResponse> => {
      const payload = {
        content_type: "STANDARD_SET",
        data: {
          title,
          content_type: "STANDARD_SET",
        },
      };

      const response = await api().put<IStandardsSetContentRelationResponse>(
        `${ApiCatalog.draftContent.endpoint}${standardsSetId}/`,
        payload,
      );
      return response;
    },
  });
};
